import Footer from 'components/footer/footer';
import Header from 'components/header/header';
import Main from 'components/main/main';

const HomePage = () => {
  return (
    <>
      <Header />
      <Main />
      <Footer />
    </>
  );
};

export default HomePage;
